import { Modal, Typography, Alert, Button } from 'antd'

const { Link, Paragraph } = Typography;

export type Props = {
  visible: boolean,
  link: string,
  linkIsFromExistingProposal?: boolean, 
  onClose: () => void
}

const LinkCreatedModal = ({ visible, link, linkIsFromExistingProposal, onClose }: Props) => {
  const footer = [
    <Button type="primary" onClick={onClose} key="ok">OK</Button>
  ]

  return <Modal open={visible} title="Proposal Link" footer={footer} onCancel={onClose}>
    {!linkIsFromExistingProposal && <Paragraph>
      The proposal has been created. You can share the link below with your customer to have them review and approve the digital proposal.
    </Paragraph>}
    <Alert message={<Link href={link} target="_blank" rel="noreferrer noopener" copyable>{link}</Link>}></Alert>
  </Modal>
}
export default LinkCreatedModal
